import { render, staticRenderFns } from "./address-info.vue?vue&type=template&id=9d318d6a&scoped=true"
import script from "./address-info.vue?vue&type=script&lang=js"
export * from "./address-info.vue?vue&type=script&lang=js"
import style0 from "./address-info.vue?vue&type=style&index=0&id=9d318d6a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d318d6a",
  null
  
)

export default component.exports